/** @format */

import React, { useState, useEffect } from "react";
// Table
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationTotalStandalone,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider from "react-bootstrap-table2-toolkit";

import useSettings from "stores/settings";
import { FormatDate } from "components/FormatDate";
import { BasicAlert } from "components/Alert";
import SearchTable from "components/search/SearchTable";

import { columns } from "components/columns/CustomerService/CustomerInquireColumns";
import { projectFirestore } from "components/ProjectFirestore";

import DeleteModal from "components/modal/DeleteModal";
import InquireModal from "components/modal/InquireModal";

const Inquire = () => {
  const settings = useSettings();
  const [datas, setDatas] = useState([]);
  const [tab, setTab] = useState("all");
  const [updateData, setUpdateData] = useState(true);

  const [modalVisible, setModalVisible] = useState(false);
  useEffect(async () => {
    if (settings.email)
      try {
        const collectionRef = projectFirestore.collection("users").doc(settings.email).collection("aisoInquire");
        const tempDatas = [];

        const collectionValue = await collectionRef.orderBy("createdAt", "desc").get();
        collectionValue.forEach((doc) => {
          tempDatas.push({ ...doc.data(), id: doc.id });
        });
        if (tab === "all") {
          setDatas(tempDatas);
        } else {
          setDatas(tempDatas.filter((f) => f.status === tab));
        }
      } catch (error) {
        console.error(error);
      }
  }, [tab, updateData]);

  return (
    <div className="border-table">
      <ToolkitProvider keyField="id" bootstrap4 data={datas} columns={columns} search>
        {(props) => (
          <div>
            {/* search table */}
            <div className="w-full">
              <SearchTable props={props} size={"col-md-12"} />
            </div>
            <div className="px-3 mt-4">
              <div className="flex justify-between items-center">
                <InquireCategory tab={tab} setTab={setTab} />
                <div>
                  <button type="button" className="btn btn-primary btn-sm min-w-max font-bold" onClick={() => setModalVisible(true)}>
                    문의하기
                  </button>
                </div>
              </div>
            </div>
            <PaginationProvider
              pagination={paginationFactory({
                custom: true,
                totalSize: datas ? datas.length : 0,
              })}
            >
              {({ paginationProps, paginationTableProps, datas }) => (
                <div className="p-3">
                  <BootstrapTable
                    keyField="id"
                    data={datas}
                    columns={columns}
                    noDataIndication=" "
                    {...paginationTableProps}
                    {...props.baseProps}
                    wrapperClasses="table-responsive"
                    classes="mytable-hover2 border-table"
                    rowClasses="mytable-hover-row2"
                    expandRow={{
                      showExpandColumn: true,
                      expandColumnPosition: "right",
                      expandHeaderColumnRenderer: ({ isAnyExpands }) => {
                        if (isAnyExpands) {
                          return <b className="cursor-pointer border py-1 px-2 rounded-full">-</b>;
                        }
                        return <b className="cursor-pointer border py-1 px-2 rounded-full">+</b>;
                      },
                      expandColumnRenderer: ({ expanded }) => {
                        if (expanded) {
                          return <b className="cursor-pointer bg-red-100 py-1 px-2.5 rounded-full text-danger">-</b>;
                        }
                        return <b className="cursor-pointer bg-blue-100 py-1 px-2 rounded-full text-primary">+</b>;
                      },
                      renderer: (datas) => DetailContent(updateData, setUpdateData, { ...datas }),
                    }}
                  />
                  <div className="flex justify-between items-center w-full">
                    <PaginationListStandalone {...paginationProps} />
                    <div className="flex justify-end">
                      <PaginationTotalStandalone {...paginationProps} />
                    </div>
                  </div>
                </div>
              )}
            </PaginationProvider>
          </div>
        )}
      </ToolkitProvider>
      <InquireModalContent
        modalVisible={modalVisible}
        closeModal={() => setModalVisible(false)}
        updateData={updateData}
        setUpdateData={setUpdateData}
      />
    </div>
  );
};

const InquireModalContent = ({ modalVisible, closeModal, updateData, setUpdateData }) => {
  const settings = useSettings();
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");

  const handleModalOkButton = async () => {
    const date = new Date();
    const createdAt = FormatDate(date);
    if (title === "") {
      const text = "문의 제목을 입력해주세요.";
      BasicAlert(text);
      return;
    }
    if (content === "") {
      const text = "문의 내용을 입력해주세요.";
      BasicAlert(text);
      return;
    }
    /**
     * 보낸 문의 저장 위치 : users/{ 보낸 사람 email }/aisoInquire/{randomId}
     * 받은 문의 저장 위치 : customerService/inquire/items/{randomId}
     */

    const status = "대기중";
    const { email } = settings;
    try {
      const values = {
        title,
        content,
        createdAt,
        email,
        status,
        answer: "",
        answeredAt: "",
      };
      const collectionRefAiso = await projectFirestore.collection("customerService").doc("inquire").collection("items");
      const newDoc = await collectionRefAiso.add(values);

      const docRefUser = await projectFirestore.collection("users").doc(email).collection("aisoInquire").doc(newDoc.id);
      await docRefUser.set(values);

      await setUpdateData(!updateData);
      setTitle("");
      setContent("");
      closeModal();
    } catch (error) {
      console.log(error);
      BasicAlert("문의 등록 실패");
    }
  };
  const handleInit = () => {
    setTitle("");
    setContent("");
    closeModal();
  };
  return (
    <InquireModal
      modalVisible={modalVisible}
      closeModal={handleInit}
      handleModalOkButton={handleModalOkButton}
      title={title}
      setTitle={setTitle}
      content={content}
      setContent={setContent}
    />
  );
};

{
  /* 카테고리 선택 */
}
const InquireCategory = ({ tab, setTab }) => {
  const tabClick = (value) => {
    setTab(value);
  };
  return (
    <div className="w-full mb-3">
      <ul className="flex items-center m-0">
        <li className="nav-item">
          <a className={`nav-link category-simple-menu ${tab === "all" ? "active" : ""}`} onClick={() => tabClick("all")}>
            전체
          </a>
        </li>
        <li className="category-simple-menu-line">|</li>
        <li className="nav-item">
          <a className={`nav-link category-simple-menu ${tab === "답변완료" ? "active" : ""}`} onClick={() => tabClick("답변완료")}>
            답변완료
          </a>
        </li>
        <li className="category-simple-menu-line">|</li>
        <li className="nav-item">
          <a className={`nav-link category-simple-menu no-content ${tab === "대기중" ? "active" : ""}`} onClick={() => tabClick("대기중")}>
            대기중
          </a>
        </li>
      </ul>
    </div>
  );
};

const DetailContent = (updateData, setUpdateData, { id, email, title, content, createdAt, answer, answeredAt }) => (
  <InquireContent
    id={id}
    email={email}
    title={title}
    content={content}
    createdAt={createdAt}
    answer={answer}
    answeredAt={answeredAt}
    updateData={updateData}
    setUpdateData={setUpdateData}
  />
);

/* 문의 내용 */
const InquireContent = ({ id, email, title, content, createdAt, answer, answeredAt, updateData, setUpdateData }) => {
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  return (
    <>
      <div className="w-full px-5 mb-3">
        <p className="text-xs text-primary font-bold mb-3">AISO 1:1 문의</p>
        <div className="pb-3 px-5">
          <p className="w-full mb-0 text-333 text-base break-words leading-5 font-bold">{title}</p>
          <div className="w-full mb-0 text-333 text-base break-words leading-5 mt-3" dangerouslySetInnerHTML={{ __html: content }} />
          <p className="mb-0 text-888 mt-3">{createdAt}</p>
          <div className="mt-3 text-left">
            <button className="btn btn-outline-grayDanger text-xs p-2 font-bold" onClick={() => setDeleteModalVisible(true)}>
              문의 취소
            </button>
          </div>
        </div>

        {answeredAt ? (
          <div className="w-full pt-3 border-t border-gray-300">
            <p className="text-xs text-primary font-bold mb-3">답글</p>
            <div className="px-5">
              <p className="w-full mb-0 text-333 text-base break-words leading-5">{answer}</p>
              <p className="mb-0 text-888 mt-3">{answeredAt}</p>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
      <InquireDeleteModal
        id={id}
        email={email}
        deleteModalVisible={deleteModalVisible}
        setDeleteModalVisible={setDeleteModalVisible}
        updateData={updateData}
        setUpdateData={setUpdateData}
      />
    </>
  );
};

/* Inquire 삭제 모달 */
const InquireDeleteModal = ({ id, email, deleteModalVisible, setDeleteModalVisible, updateData, setUpdateData }) => {
  const handleInquireRemove = async () => {
    try {
      const docRefAiso = await projectFirestore.collection("customerService").doc("inquire").collection("items").doc(id);
      const docRefUser = await projectFirestore.collection("users").doc(email).collection("aisoInquire").doc(id);
      await docRefAiso.delete();
      await docRefUser.delete();

      setUpdateData(!updateData);
      setDeleteModalVisible(false);
    } catch (error) {
      console.log(error);
      BasicAlert("삭제 에러");
    }
  };
  return (
    <DeleteModal
      modalVisible={deleteModalVisible}
      closeModal={() => setDeleteModalVisible(false)}
      handleDeleteOkModal={handleInquireRemove}
      target={`문의를`}
    />
  );
};

export default Inquire;
